import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const updateKbUserRole = createAsyncThunk(
  'userRole/update',
  async ({ userId, businessId, role, group_id }, { getState, rejectWithValue }) => {
    const { loginToken } = getState();
    const authToken = loginToken?.response?.token;

    console.log('Making request to:', `${ROOT_URL}/trustchat-backend-service/v1/kb/user-role`);

    try {
      const response = await fetch(
        `${ROOT_URL}/kb/user-role`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify({
            userId,
            business_id: businessId,
            role,
            group_id,
          }),
        },
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      return rejectWithValue(error.message || error);
    }
  },
);

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: null,
  error: null,
};

const updateKbUserRoleSlice = createSlice({
  name: 'updateKbUserRole',
  initialState,
  reducers: {
    resetState: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.isCompleted = false;
      state.response = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateKbUserRole.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.isCompleted = false;
      })
      .addCase(updateKbUserRole.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.isCompleted = true;
        state.response = action.payload;
      })
      .addCase(updateKbUserRole.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.isCompleted = true;
        state.error = action.payload;
      });
  },
});

export const { resetState } = updateKbUserRoleSlice.actions;
export default updateKbUserRoleSlice.reducer;